// extracted by mini-css-extract-plugin
export default {"customLink":"FormAddDevices_customLink__bqheb","subtitleInput":"FormAddDevices_subtitleInput__2u-M3"};